/* eslint-disable i18next/no-literal-string -- cache key segments */
const toolConfigScopesKey = (toolId: string) =>
  ['admin', 'tools', 'config-scopes', toolId] as const;

export const ADMIN_QUERY_KEYS = {
  modelProviders: {
    all: ['admin', 'model-providers', 'all-providers'] as const,
    whitelisted: ['admin', 'model-providers', 'whitelisted'] as const,
  },
  tools: {
    agents: ['admin', 'tools', 'agents'] as const,
    orgWorkspaces: ['admin', 'tools', 'org-workspaces'] as const,
    accessOverview: ['admin', 'tools', 'access-overview'] as const,
    schemas: ['admin', 'tools', 'schemas'] as const,
    configScopes: toolConfigScopesKey,
    toolDetail: ['admin', 'tool-detail'] as const,
    toolConfig: ['admin', 'tool-config'] as const,
    agentConfig: (agentId: string) => ['admin', 'tools', 'agent-config', agentId] as const,
    agentWorkspaceConfigs: (agentId: string) =>
      ['admin', 'tools', 'agent-workspace-configs', agentId] as const,
  },
  mcpCatalog: {
    available: ['admin', 'mcp-catalog', 'available'] as const,
  },
} as const;
